import styles from "./Title.module.sass";

interface TitleProps {
  content: string;
}

export const Title = ({ content }: TitleProps) => {
  return <h1 className={styles.Title} dangerouslySetInnerHTML={{ __html: content }} />;
};
